module.exports = __webpack_public_path__ + "img/weathertop-3018-10-06.f6486cf7.jpg";